import { createSelector } from 'reselect'
// import { List } from 'immutable'

const employeeLevelsSelector = state => state.get('employeeLevels')

export const getIsFetching = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsCreate.isFetching
    || employeeLevels.employeeLevelsEdit.isFetching
    || employeeLevels.employeeLevelsDeactivate.isFetching
    || employeeLevels.employeeLevelsGet.isFetching
    || employeeLevels.employeeLevelsList.isFetching
    || employeeLevels.employeeLevelsExport.isFetching
  }
)
export const getCreateEmployeeLevelsData = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsCreate
  }
)
export const getEditEmployeeLevelsData = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsEdit
  }
)
export const getDeactivateEmployeeLevelsData = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsDeactivate
  }
)
export const getGetEmployeeLevelsData = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsGet.employeeLevels
  }
)
export const getListEmployeeLevels = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsList.employee || []
  }
)
export const getExportURL = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return employeeLevels.employeeLevelsExport.url
  }
)
export const redirectEmployeeLevels = createSelector(
  employeeLevelsSelector,
  employeeLevelsImmutable => {
    const employeeLevels = employeeLevelsImmutable.toJS()
    return ({
      redirect: (employeeLevels.employeeLevelsCreate.redirect
      || employeeLevels.employeeLevelsEdit.redirect
      || employeeLevels.employeeLevelsDeactivate.redirect
      || employeeLevels.employeeLevelsGet.redirect
      || employeeLevels.employeeLevelsList.redirect
      || employeeLevels.employeeLevelsExport.redirect),
      isAuthenticated: (employeeLevels.employeeLevelsCreate.isAuthenticated
      || employeeLevels.employeeLevelsEdit.isAuthenticated
      || employeeLevels.employeeLevelsDeactivate.isAuthenticated
      || employeeLevels.employeeLevelsGet.isAuthenticated
      || employeeLevels.employeeLevelsList.isAuthenticated
      || employeeLevels.employeeLevelsExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/employee-levels/employee-levels-selector.js